import { BaseEnum } from "../../BaseEnum";

export class VehicleType extends BaseEnum {
  // 99, non 0: allineato a VehicleType.cs, alla config dei fattori e alla select di a.3.0.17.t_1.
  static CAR_UNKNOWN_SIZE_AND_FUEL = 99;
  static SMALL_CAR_PETROL = 1;
  static MEDIUM_CAR_PETROL = 2;
  static LARGE_CAR_PETROL = 3;
  static AVERAGE_CAR_PETROL = 4;
  static SMALL_CAR_DIESEL = 5;
  static MEDIUM_CAR_DIESEL = 6;
  static LARGE_CAR_DIESEL = 7;
  static AVERAGE_CAR_DIESEL = 8;
  static CAR_LPG = 9;
  static CAR_EV = 10;
  static CAR_PLUG_IN_HYBRID = 11;
  static CAR_HYBRID = 12;
  static MOTORBIKE = 13;
  static VAN_PETROL = 14;
  static VAN_DIESEL = 15;
  static VAN_LPG = 16;
  static VAN_PLUG_IN_HYBRID = 17;
  static VAN_EV = 18;
  static TRUCK_HGV = 19;
  static TRUCK_HGV_REFRIGERATED = 20;
  static PASSENGER_CAR = 21;
  static VAN_LIGHT_DUTY_TRUCK = 22;
  static MEDIUM_AND_HEAVY_DUTY_TRUCK = 23;

  static Codes = [
    this.CAR_UNKNOWN_SIZE_AND_FUEL,
    this.SMALL_CAR_PETROL,
    this.MEDIUM_CAR_PETROL,
    this.LARGE_CAR_PETROL,
    this.AVERAGE_CAR_PETROL,
    this.SMALL_CAR_DIESEL,
    this.MEDIUM_CAR_DIESEL,
    this.LARGE_CAR_DIESEL,
    this.AVERAGE_CAR_DIESEL,
    this.CAR_LPG,
    this.CAR_EV,
    this.CAR_PLUG_IN_HYBRID,
    this.CAR_HYBRID,
    this.MOTORBIKE,
    this.VAN_PETROL,
    this.VAN_DIESEL,
    this.VAN_LPG,
    this.VAN_PLUG_IN_HYBRID,
    this.VAN_EV,
    this.TRUCK_HGV,
    this.TRUCK_HGV_REFRIGERATED,
    this.PASSENGER_CAR,
    this.VAN_LIGHT_DUTY_TRUCK,
    this.MEDIUM_AND_HEAVY_DUTY_TRUCK,
  ];

  static _labelKeys = [
    "enums.vehicle-type.CAR_UNKNOWN_SIZE_AND_FUEL",
    "enums.vehicle-type.SMALL_CAR_PETROL",
    "enums.vehicle-type.MEDIUM_CAR_PETROL",
    "enums.vehicle-type.LARGE_CAR_PETROL",
    "enums.vehicle-type.AVERAGE_CAR_PETROL",
    "enums.vehicle-type.SMALL_CAR_DIESEL",
    "enums.vehicle-type.MEDIUM_CAR_DIESEL",
    "enums.vehicle-type.LARGE_CAR_DIESEL",
    "enums.vehicle-type.AVERAGE_CAR_DIESEL",
    "enums.vehicle-type.CAR_LPG",
    "enums.vehicle-type.CAR_EV",
    "enums.vehicle-type.CAR_PLUG_IN_HYBRID",
    "enums.vehicle-type.CAR_HYBRID",
    "enums.vehicle-type.MOTORBIKE",
    "enums.vehicle-type.VAN_PETROL",
    "enums.vehicle-type.VAN_DIESEL",
    "enums.vehicle-type.VAN_LPG",
    "enums.vehicle-type.VAN_PLUG_IN_HYBRID",
    "enums.vehicle-type.VAN_EV",
    "enums.vehicle-type.TRUCK_HGV",
    "enums.vehicle-type.TRUCK_HGV_REFRIGERATED",
    "enums.vehicle-type.PASSENGER_CAR",
    "enums.vehicle-type.VAN_LIGHT_DUTY_TRUCK",
    "enums.vehicle-type.MEDIUM_AND_HEAVY_DUTY_TRUCK",
  ];
}
